import React from "react";
import { createUseStyles } from "react-jss";
import { RichTextField } from "../common/richTextField/RichTextField";

const useStyles = createUseStyles({
  textBlock: {
    width: "100%",
    margin: ({ margin }) => margin,
    padding: ({ padding }) => padding,
    fontFamily: ({ font }) => font,
  },
  pullQuote: {
    margin: "16px 0",
    paddingLeft: "20px",
    borderLeft: "4px solid #4484F1",
    fontStyle: "italic",
  },
  quoteAuthor: {
    display: "block",
    marginTop: "8px",
    fontSize: "0.9em",
    fontStyle: "normal",
    color: "#555555",
  },
});

export const TextBlock = ({ block }) => {
  const { margin, padding, font, text } = block || {};
  const isPullQuote = Boolean(block?.isPullQuote || block?.variant === "pull-quote");
  const quoteAuthor = block?.quoteAuthor;

  const classes = useStyles({
    margin,
    padding,
    font,
  });

  const content = text ? (
    <RichTextField showToolbar={false} value={text} readOnly={true} />
  ) : null;

  return (
    <div className={classes.textBlock}>
      {isPullQuote ? (
        <blockquote data-testid="pull-quote" className={classes.pullQuote}>
          {content}
          {quoteAuthor && (
            <cite data-testid="quote-author" className={classes.quoteAuthor}>
              {quoteAuthor}
            </cite>
          )}
        </blockquote>
      ) : (
        content
      )}
    </div>
  );
};
